import "./Hover_Nav.css"

export default function UnderCons() { 

    return ( 
        <div className="product">
            <img src="https://giffiles.alphacoders.com/158/158667.gif" alt="underConstruction"/>
    </div>
)

}